
import {Component, Vue} from 'vue-property-decorator';
import AppStore from '@/components/AppStore';

@Component({})
export default class MenuTop extends Vue {
  isFinesEnabled = AppStore.isFinesEnabled;
  isRnisEmulationEnabled = AppStore.isRnisEmulationEnabled;
}
